import type { FirebaseOptions } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import firebase from 'firebase/compat/app'; // Need compat for redux-firestore.
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/messaging';
import { getFirestore } from 'firebase/firestore';
import { compose, legacy_createStore } from 'redux';
import { firestoreReducer as realFirestoreReducer, reduxFirestore } from 'redux-firestore';
import { IS_DEV, IS_STAGING } from 'src/environment';
import { getMockActions, getMockReducers } from '../@solink/utils/reduxMocker';
import './firebase.mock';

// Enable to use mock data in firebase.
const IS_MOCKING_ENABLED = false;

let store: any;

export const VAPID_KEY: string =
  IS_DEV || IS_STAGING
    ? 'BFcpuQfAM5_apIxZ2D1nTDTrJkROOAoFo4l-63i1JRlKYFsGcbOlHakjl6dr_-sO5jFDSR9tPoXBsSIE2Rnzf7k'
    : 'BJBHoWhR20Cktxi9boj1ECsQ1K5BuHy3NkOMdlgsJyZJ5h2spqGmHywclxFCTU21i85-tX4z45pLsgdWH5oiER8';

export const FIREBASE_CONFIG: FirebaseOptions & { apiKey: string } =
  IS_DEV || IS_STAGING
    ? {
        apiKey: 'AIzaSyBfKsE7VTU16BNyFvv-cGMyv9askTcG2-k',
        authDomain: 'solinkcloud-dev.firebaseapp.com',
        databaseURL: 'https://solinkcloud-dev.firebaseio.com',
        projectId: 'solinkcloud-dev',
        storageBucket: 'solinkcloud-dev.appspot.com',
        messagingSenderId: '393765911053',
        appId: '1:393765911053:web:93f80677761065a4ea3344',
      }
    : {
        apiKey: 'AIzaSyCja5TW5chMVbdUbXsgp9LWA3FHVvsB7po',
        appId: '1:529651882006:web:82462abe4f021d02bcfd37',
        authDomain: 'solink-video-discovery-android.firebaseapp.com',
        databaseURL: 'https://solink-video-discovery-android.firebaseio.com',
        projectId: 'solink-video-discovery-android',
        storageBucket: 'solink-video-discovery-android.appspot.com',
        messagingSenderId: '529651882006',
      };

// Initialize firebase instance
export const firebaseApp = firebase.initializeApp(FIREBASE_CONFIG);
// Initialize Cloud Firestore and get a reference to the service
getFirestore(firebaseApp);

// Add Firebase to reducers
const { firestore: mockFirestore } = getMockReducers();

export const firestoreReducer = IS_MOCKING_ENABLED ? mockFirestore : realFirestoreReducer;
export const firebaseAuth = getAuth(firebaseApp);

// Add reduxFirestore store enhancer to store creator
export const createStoreWithFirebase = (reducer: any, initialState: any, middleware: any): any => {
  const createStoreHelper = compose(reduxFirestore(firebase, {}))(legacy_createStore);

  store = createStoreHelper(reducer, initialState, middleware);

  // MOCK ACTIONS ///////////////////////////////////////////////////////////////////////////////////////////////////////
  // NOTE: we could either pass in these actions via the Redux `connect` function or,
  // in this case, add it directly to `firestore`, since that's how we interface with it.
  // SET ACTIONS INTO FIRESTORE //
  if (IS_MOCKING_ENABLED) {
    const { get, setListener, unsetListener, update } = getMockActions(store.dispatch);
    store.firestore.get = get;
    store.firestore.setListener = setListener;
    store.firestore.unsetListener = unsetListener;
    store.firestore.update = update;
  }

  return store;
};
